/* global jQuery */

;(function ($) {

	'use strict';

	/**
	 * @param {HTMLElement} element
	 * @param {*} options
	 * @constructor
	 */
	function ModuleStageVideo(element, options) {
		this.$element = $(element);
		this.options = options;
		this.initialize();
	}

	ModuleStageVideo.prototype.initialize = function () {
		this.$videoWrapper = this.$element.find('.stage__video');
		this.$closeIcon = this.$element.find('.stage__closeicon');

		this.playerActiveClass = this.$element.data('active-class');
		this.closeIconHideClass = this.$closeIcon.data('hide-class');

		this.isMouseOverVideo = false;

		this.player = '';

		this.isYoutubeVideo = this.$element.find('.video').hasClass('video--youtube');

		// init objectFit polyfill on megaStage images
		if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
			$('.stage__image img').objectFit();
		}

		if(this.isYoutubeVideo) {
			var self = this;
			this.$videoWrapper.on('mouseover', function() {
				self.isMouseOverVideo = true;
			});
			this.$videoWrapper.on('mouseout', function() {
				self.isMouseOverVideo = false;
			});
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://www.youtube.com/iframe_api';
			document.body.appendChild(script);
		} else {
			this.$videoWrapper.moduleVideoPlayer({
				fluid: true,
				preload: 'metadata'
			});

			this.videoInstance = this.$videoWrapper.get(0).player;
		}

		this.setupListeners();
	};

	ModuleStageVideo.prototype.setupListeners = function () {
		var self = this,
			KEY_CODE_ESC = 27;

		this.$element.on('click', function (event) {
			event.preventDefault();

			if (!self.isVideoVisible()) {
				self.showVideo();
			}
		});

		this.$closeIcon.on('click', function (event) {
			event.preventDefault();
			event.stopPropagation();

			self.hideVideo();
		});

		$(document).on('keyup.stopVideo', function (event) {
			if (event.keyCode === KEY_CODE_ESC) {
				self.$closeIcon.trigger('click');
			}
		});
	};

	/**
	 * @returns {boolean}
	 */
	ModuleStageVideo.prototype.isVideoVisible = function () {
		return this.$element.hasClass(this.playerActiveClass);
	};

	ModuleStageVideo.prototype.showVideo = function () {
		var self = this;
		this.$element.addClass(this.playerActiveClass);
		if (this.isYoutubeVideo) {
			var $iframe = this.$element.find('.video__iframe');
			if ($iframe.attr('src').length === 0) {
				var videoUrl = this.$element.find('.video').data('yt-id');
				$iframe.attr('src', this.prepareYoutubeUrl(videoUrl));
				if(YT) {
					self.player = new YT.Player($iframe[0], {
						events: {
							onReady: function() {
								self.player.playVideo();
							},
							onStateChange: function(event) {
								if (event.data === YT.PlayerState.PLAYING) {
									self.synchronizeCloseIcon(true);
								}
								if (event.data === YT.PlayerState.PAUSED) {
									self.$closeIcon.removeClass(self.closeIconHideClass);
									self.synchronizeCloseIcon(false);
								}
								if (event.data === YT.PlayerState.ENDED) {
									self.$closeIcon.removeClass(self.closeIconHideClass);
									self.synchronizeCloseIcon(false);
								}
							}
						}
					});
				}
			} else {
				self.player.playVideo();
			}
		} else {
			this.videoInstance.play();
			this.synchronizeCloseIcon(true);
		}
	};

	ModuleStageVideo.prototype.hideVideo = function () {
		this.$element.removeClass(this.playerActiveClass);
		if (this.isYoutubeVideo) {
			this.player.pauseVideo();
		} else {
			this.videoInstance.pause();
			this.synchronizeCloseIcon();
		}
	};

	ModuleStageVideo.prototype.prepareYoutubeUrl = function (id) {
		var createEmedUrl = function (id) {
			var baseUrl = 'https://www.youtube-nocookie.com/embed/';
			var autoplay = 'autoplay=1';
			var rel = '&rel=0';
			var showinfo = '&showinfo=0';
			var jsAPI = '&enablejsapi=1';
			var color = '&color=white';
			var parameters = autoplay + rel + showinfo + color + jsAPI;
			var embedUrl = baseUrl + id + '?' + parameters;
			return embedUrl;
		};
		return createEmedUrl(id);
	};

	/**
	 * @param {boolean} [activate] true to start, false or nothing to stop.
	 */
	ModuleStageVideo.prototype.synchronizeCloseIcon = function (activate) {
		var self = this,
			$videoJs;

		if (!activate) {
			window.clearInterval(self.closeIconPromise);
			return;
		}


		$videoJs = this.$element.find('.video-js');

			/*
			* If there is an event hook you may change it to that.
			*/
		self.closeIconPromise = window.setInterval(function () {
			self.$closeIcon.toggleClass(
				self.closeIconHideClass,
				self.isYoutubeVideo ? !self.isMouseOverVideo : $videoJs.hasClass('vjs-user-inactive')
			);
		}, 150);
	};

	/**
	 * @param {*} [options]
	 * @returns {jQuery}
	 */
	$.fn.moduleStageVideo = function (options) {
		this.each(function () {
			$.singletonPlugin(this, 'module-stage-video', ModuleStageVideo, options);
		});

		return this;
	};

})(jQuery);
